import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import { useArticleTitle } from '@article/shared/utils/use-article-title';
import { useArticleDescription } from '@article/shared/utils/use-article-description';
import { ArticleDetailUtil } from 'shared/models';
import { CommonPageTWCard } from '@lemon8/web-app-shared/ssr';

export const ArticleTwitter = () => {
  const getTwCardImage = () => {
    const article = useAtomValue($CurrentArticle);
    const imageMeta = useMemo(() => {
      if (!ArticleDetailUtil.isArticleAvailable(article)) {
        return null;
      }
      return ArticleDetailUtil.getCoverImage(article);
    }, []);
    return imageMeta?.url || '';
  };

  const twitterCardInfo = {
    twCardTitle: useArticleTitle(),
    twCardDesc: useArticleDescription(),
    twCardImageSrc: getTwCardImage(),
  };

  return <CommonPageTWCard {...twitterCardInfo} />;
};
